import React from "react";
import { Play } from "lucide-react";

const videos = [
  {
    id: "oRFxNi6hkpw",
    title: "Live Set · Featured Performance",
    href: "https://www.youtube.com/watch?v=oRFxNi6hkpw&t=1724s",
  },
  {
    id: "RRn52ySTUgY",
    title: "Full Live Concert",
    href: "https://www.youtube.com/live/RRn52ySTUgY?si=kKsA4pAbtWZcs3HR",
  },
  {
    id: "S1Rk0VSANYA",
    title: "On Stage",
    href: "https://youtu.be/S1Rk0VSANYA?si=D-BFm3Cq_4opzfOB",
  },
  {
    id: "wmPQzX0L41I",
    title: "Live Cut",
    href: "https://youtu.be/wmPQzX0L41I?si=t9bKUWq2lqW4YTzv",
  },
  {
    id: "WmHCBAW4MEU",
    title: "On Tour",
    href: "https://youtu.be/WmHCBAW4MEU?si=uoJb57jdAb1j6WnF",
  },
];

const thumb = (id, size = "hqdefault") => `https://img.youtube.com/vi/${id}/${size}.jpg`;
export default function Videos() {
  return (
    <section
      id="videos"
      data-testid="videos-section"
      className="relative pt-6 md:pt-8 pb-14 md:pb-20 px-6 md:px-12 bg-vintage-bg2"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <h2 className="font-heading text-5xl md:text-7xl uppercase text-vintage-gold tracking-wide leading-none">
              Live Videos
            </h2>
          </div>
        </div>

        {/* Uniform grid — works cleanly on mobile and desktop */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {videos.map((v, idx) => (
            <a
              key={v.id}
              href={v.href}
              data-testid={`video-card-${idx}`}
              className="group relative block bg-vintage-bg border border-vintage-cream/10 hover:border-vintage-rust/60 transition-colors overflow-hidden"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={thumb(v.id, "hqdefault")}
                  onError={(e) => { e.currentTarget.src = thumb(v.id, "mqdefault"); }}
                  alt={v.title}
                  loading="lazy"
                  className="w-full h-full object-cover scale-[1.32] transition-transform duration-700 group-hover:scale-[1.4]"
                  style={{ filter: "contrast(1.05) saturate(0.95)" }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-vintage-bg/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="bg-vintage-rust text-vintage-cream w-14 h-14 rounded-full flex items-center justify-center vintage-shadow-sm group-hover:bg-vintage-burgundy transition-colors">
                    <Play size={22} className="fill-current ml-0.5" />
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
